import { Button } from '@sendsprint/ui-react';
import { useAccount, useDashboardContext, useEnv } from '@src/contexts';
import { useConfigurationsContext } from '@src/contexts/configurations-context';
import React from 'react';
import DiagonalArrowRightUpOutline from '@sendsprint/ui-react/dist/icons/DiagonalArrowRightUpOutline';

const VisitPreview = () => {
  const { B2C_STAGING_WHITE_LABEL_URL } = useEnv();

  const { isWhiteLabelBusiness } = useAccount();
  const { isBusinessVerified } = useDashboardContext();
  const { shouldShowPreview, configurationData } = useConfigurationsContext();

  const handlePreview = () => {
    const domain = configurationData?.data?.domainSettings?.domainName;
    const testUrl = `${B2C_STAGING_WHITE_LABEL_URL}?preview=${domain}`;
    window.open(testUrl);
  };

  if (!isWhiteLabelBusiness || !shouldShowPreview || !isBusinessVerified) return <></>;

  return (
    <Button
      size="small"
      iconRight={DiagonalArrowRightUpOutline}
      variant="secondary"
      label="Visit Test Site"
      onClick={handlePreview}
    />
  );
};

export default VisitPreview;
